module.exports = "<section class=\"content loading-container\">\n  <app-loader></app-loader>\n  <span>{{loadingMessage ? loadingMessage : 'Please, wait...'}}</span>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/content-loader/content-loader.component.html
// module id = ./src/app/components/content-loader/content-loader.component.html
// module chunks = main